import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useAuthContext, useFlavoursContext } from '@hooks';
import { initialFlavoursContext } from '@context';
import { HeaderLayout } from '@layouts';
import { ROUTES } from '@constants';

import SlidersList from './SlidersList';
import ButtonGroup from './ButtonGroup';
import BottomButtonComponent from './BottomButtonComponent';

import { useStyles } from './styles';

function SliderScreen() {
  const history = useHistory();
  const classes = useStyles();

  const [flavoursList, setFlavoursList] = useState(initialFlavoursContext);
  const [answerFlavour, setAnswerFlavour] = useState('');

  const { session } = useAuthContext();
  const { setFlavours } = useFlavoursContext();

  const memoizedUpdateValueSlider = useCallback(({ target }, value) => {
    setFlavoursList(prevState =>
      prevState.map(item =>
        item.id === target.ariaLabel ? { ...item, value } : item,
      ),
    );
  }, []);

  const memoizedUpdateAnswer = useCallback(
    answer => () => {
      setAnswerFlavour(answer);
    },
    [],
  );

  const memoizedUpdateFlavours = useCallback(() => {
    setFlavours(flavoursList, answerFlavour);

    history.push(ROUTES.OCCASION_SCREEN, {
      from: ROUTES.SLIDER_SCREEN,
    });
    // eslint-disable-next-line
  }, [answerFlavour]);

  useEffect(() => {
    if (!session?.authenticated) history.push('/');
    // eslint-disable-next-line
  }, []);

  return (
    <HeaderLayout>
      <div className={classes.container}>
        <Box>
          <Typography className={classes.title}>
            {'Howdy, lets find your perfect cocktail'}
          </Typography>
          <span className={classes.divider} />
        </Box>
        <SlidersList
          flavoursList={flavoursList}
          handleChangeFlavoursValue={memoizedUpdateValueSlider}
        />
        <ButtonGroup handleClick={memoizedUpdateAnswer} />
        <BottomButtonComponent
          disabled={!answerFlavour}
          handleClick={memoizedUpdateFlavours}
        />
      </div>
    </HeaderLayout>
  );
}

export default SliderScreen;
